import Link from 'next/link'
import React, { useState } from 'react'
import styled from 'styled-components'
import { useRouter } from 'next/router'
import LazyLoad from 'react-lazyload'
import { eventLogProducer } from '@/lib/event-logger'
import { Action } from '@@/action_pb'
import { useWindowSize } from '@/lib/use-hooks/use-window-size'
import { createResource, useResource } from '@/lib/i18n'
import { playPath, shimmer, toBase64 } from '@/lib/utils'
import { IDownloadType, ILocation } from '@/lib/enums/device'
import IosDownloadBtn from '../common/ios-download-btn'
import Image from 'next/image'



const resource = createResource({
  en: {
    apkText: 'Scan To Download App',
  },
  id: {
    apkText: 'Scan untuk Download Aplikasinya',
  },
})

const BlogSearch = () => {
  const { t } = useResource(resource)
  const [question, setQuestion] = useState('')
  const { width } = useWindowSize()
  const isMobile = width < 1000;
  const router = useRouter()
  const onKeyup = (e) => {
    if (e.keyCode === 13) {
      router.push(`/search?q=${question}`)
    }
  }

  const eventClick = () => {
    eventLogProducer.push({
      action: Action.GETITONGOOGLEPLAYBUTTONCLICK,
    })
  }
  const eventClickSearch = () => {
    eventLogProducer.push({
      action: Action.SEARCHBUTTONCLICK,
      extra: { queryWords: question },
    })
  }
  const goToDown = (herf: string) => {
    eventLogProducer.push({
      action: Action.GETITONAPPGALLERYBUTTONCLICK,
    })
    setTimeout(() => {
      window.open(herf)
    }, 1000)
  }
  return (
    <BannerBox>
      <div className="container">
        <div className="input-hook">
          <input
            className="input-qs"
            onKeyUp={onKeyup}
            placeholder="Cari..."
            onInput={(e: any) => setQuestion(e.target.value)}
          ></input>
          <Link href={`/search?q=${question}`}>
            <a className="search-btn" onClick={eventClickSearch}>
              <LazyLoad>
                <img className="search-icon" src={'/images/edu/search-icon.png'} alt="search-icon" />
              </LazyLoad>
            </a>
          </Link>
        </div>
        {width > 1000 ? (
          <div className='pc-download'>
            <section className="banner pc" onClick={() => goToDown(playPath(IDownloadType.GOOGLE_PLAY, 'OfficalWebsiteDownload_Home'))}>
              <LazyLoad>
                <img className="qrcode" src="/images/qrcode/qr_edu_gp.png" alt="qrcode" />
              </LazyLoad>
                {/* <img src={'/images/qrcode/edu_google.png'} alt="google_play" width={144} height={44} className='down-btn-img' /> */}
              <LazyLoad>
              <Image
                src="/images/qrcode/edu_google.png"
                className='down-btn-img'
                width={144}
                height={44}
                quality={85}
                placeholder="blur"
                blurDataURL={`data:image/svg+xml;base64,${toBase64(shimmer(144, 44))}`}
              />
              </LazyLoad>
            </section>
            <IosDownloadBtn location={ILocation.EDUCATION} isMobile={isMobile} width={144} />
          </div>
        ) : (
          <div className='mobile'>
            <a
              href={playPath(IDownloadType.GOOGLE_PLAY, 'OfficalWebsiteDownload_Blog')}
              rel="noopener noreferrer nofollow"
              onClick={() => eventClick()}
              target="_blank"
              className="banner"
            >
              <LazyLoad>
                {/* <img src={'/images/home/google_play.png'} alt="google_play" className='down-btn-img' /> */}
                <img src={'/images/qrcode/edu_google_mb.png'} alt="google_play" className='down-btn-img' />
              </LazyLoad>
            </a>
            <div className="self-down">
              <IosDownloadBtn location={ILocation.EDUCATION} isMobile={isMobile} />
            </div>
          </div>
        )}
      </div>
    </BannerBox>
  )
}

export default BlogSearch

const BannerBox = styled.div`
  @media only screen and (max-width: 1000px) {
    .container {
      width: 100%;
      margin: 0 auto;
      padding: 0 24px;
      .mobile {
        display: flex;
        justify-content: space-between;
      }
      .banner {
        display: flex;
        .down-btn-img {
          width: 130px;
          height: 41px;
        }
      }
      .self-down {
        margin-left: 12px;
      }
      .input-hook {
        position: relative;
        margin: 32px auto 40px;
        .input-qs {
          width: 100%;
          height: 40px;
          line-height: 40px;
          padding: 0 80px 0 12px;
          background: #ffffff;
          box-shadow: 0px 15px 25px 0px rgba(0, 0, 0, 0.06);
          border-radius: 8px;
        }
        .search-btn {
          position: absolute;
          right: 0;
          top: 0;
          width: 40px;
          height: 40px;
          background: #1cc812;
          border-radius: 0px 8px 8px 0px;
          display: flex;
          justify-content: center;
          align-items: center;
          .search-icon {
            width: 24px;
          }
        }
      }
    }
  }
  @media only screen and (min-width: 1000px) {
    .container {
      width: 200px;
      margin: 0 auto;
      .pc-download {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
      }
      .banner {
        margin-top: 32px;
        height: 44px;
        .down-btn-img {
          width: 144px;
          height: 44px;
        }
      }
      .pc {
        cursor: pointer;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        .qrcode {
          position: absolute;
          top: 50%;
          right: 0;
          transform: translateY(-50%);
          width: 100%;
          height: 100%;
          z-index: 1;
          opacity: 0;
        }
        .apk_text {
          position: absolute;
          font-size: 12px;
          font-family: Roboto-Medium, Roboto;
          font-weight: 500;
          color: #ffffff;
          line-height: 14px;
          letter-spacing: -0.6px;
          width: 66%;
          padding-left: 10px;
          z-index: 1;
        }
      }
      .pc:hover .qrcode {
        top: 100px;
        width: 120px;
        height: 120px;
        border-radius: 8px;
        background: #fff;
        box-shadow: 0px 6px 12px 0px rgba(0, 0, 0, 0.1);
        border: 1px solid #f5f5f5;
        opacity: 1;
        z-index: 112;
      }

      .input-hook {
        position: relative;
        margin: 20px auto 0;
        width: 200px;
        .input-qs {
          width: 200px;
          height: 56px;
          line-height: 56px;
          padding: 0 75px 0 20px;
          background: #ffffff;
          box-shadow: 0px 15px 25px 0px rgba(0, 0, 0, 0.06);
          border-radius: 8px;
        }
        /deep/ input:-webkit-input-placeholder {
          font-size: 16px;
          font-family: Roboto-Medium, Roboto;
          font-weight: 500;
          color: #959ead;
        }

        .search-btn {
          position: absolute;
          right: 0;
          top: 0;
          width: 56px;
          height: 56px;
          background: #1cc812;
          border-radius: 0px 8px 8px 0px;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          .search-icon {
            width: 24px;
          }
        }
      }
    }
  }
`
